// extracted by mini-css-extract-plugin
module.exports = {"date":"ShowSystemAnnounce__date--iXL6r","title":"ShowSystemAnnounce__title--1SvWX","body":"ShowSystemAnnounce__body--1ftBe"};